import { ICONES_MAPA, type NomeIconeMapa } from "./icones-mapa.ts";
import { ICONES, type NomeIcone } from "./icones-svg.ts";

export { mascarar } from "./mascara.ts";
export type { NomeIconeMapa };
export { ICONES, type NomeIcone };

/** Ícone de traço do VetBolso. Os caminhos são constantes do pacote, nunca vêm de conteúdo. */
export function Icone({ nome, className = "", tamanho }: { nome: NomeIcone; className?: string; tamanho?: number }) {
  return (
    <svg
      className={`ico ${className}`}
      viewBox="0 0 24 24"
      width={tamanho}
      height={tamanho}
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: SVG estático do próprio pacote
      dangerouslySetInnerHTML={{ __html: ICONES[nome] }}
    />
  );
}

/** Ícone colorido de ramo do mapa mental. Mantém as próprias cores, em qualquer tema. */
export function IconeMapa({ nome, tamanho = 40 }: { nome: NomeIconeMapa; tamanho?: number }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={tamanho}
      height={tamanho}
      aria-hidden="true"
      fill="none"
      stroke="#20242F"
      strokeWidth={2.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: SVG estático do próprio pacote
      dangerouslySetInnerHTML={{ __html: ICONES_MAPA[nome] }}
    />
  );
}

/** Marca: escudo com pata e cruz de cuidado. */
export function Logo({ tamanho = 32, titulo }: { tamanho?: number; titulo?: string }) {
  return (
    <svg width={tamanho} height={tamanho} viewBox="0 0 64 64" role={titulo ? "img" : undefined} aria-hidden={titulo ? undefined : true}>
      {titulo ? <title>{titulo}</title> : null}
      <rect width="64" height="64" rx="16" fill="#0F7A55" />
      <path d="M13 13h38v21c0 10.5-8.7 17.6-19 20.5C21.7 51.6 13 44.5 13 34z" fill="#0A5C40" />
      <path
        d="M17 17h30v17c0 8.3-6.6 14-15 16.6C23.6 48 17 42.3 17 34z"
        fill="none"
        stroke="#FFFFFF"
        strokeOpacity=".55"
        strokeWidth="1.6"
        strokeDasharray="3 2.6"
      />
      <path
        d="M32 33.2c-4.9 0-8.6 4.5-8.6 7.7 0 2.6 2.1 3.6 4 3.6 1.8 0 2.8-.9 4.6-.9s2.8.9 4.6.9c1.9 0 4-1 4-3.6 0-3.2-3.7-7.7-8.6-7.7z"
        fill="#FFFFFF"
      />
      <ellipse cx="23.6" cy="29.6" rx="2.6" ry="3.4" transform="rotate(-24 23.6 29.6)" fill="#FFFFFF" />
      <ellipse cx="28.9" cy="25.4" rx="2.6" ry="3.5" transform="rotate(-8 28.9 25.4)" fill="#FFFFFF" />
      <ellipse cx="35.1" cy="25.4" rx="2.6" ry="3.5" transform="rotate(8 35.1 25.4)" fill="#FFFFFF" />
      <ellipse cx="40.4" cy="29.6" rx="2.6" ry="3.4" transform="rotate(24 40.4 29.6)" fill="#FFFFFF" />
      <circle cx="47.5" cy="16.5" r="5.5" fill="#D9822B" />
      <path d="M47.5 13.6v5.8M44.6 16.5h5.8" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

/** Cor de cada espécie, em variáveis de tokens.css. */
export const COR_ESPECIE: Record<string, string> = {
  cao: "var(--sp-cao)",
  gato: "var(--sp-gato)",
  bovino: "var(--sp-bov)",
  equino: "var(--sp-eq)",
};
